import Popup from "./Popup";
import Icon from "./Icon";
import classNames from "classnames";
import Input from "./Input";
import Label from "./Label";
import styles from "./dropdownSelector.module.css";
import { useState, useMemo } from "react";

const DropdownSelector = ({
  options,
  value,
  defaultValue,
  onChange,
  label,
  noEmpty,
  searchable = false,
}) => {
  const [query, setQuery] = useState("");

  const safeDefault = useMemo(
    () => ({
      id: defaultValue?.id ?? null,
      label: defaultValue?.label ?? "-",
    }),
    [defaultValue?.id, defaultValue?.label],
  );

  const selectorOptions = useMemo(() => {
    if (!Array.isArray(options)) return [safeDefault];
    if (noEmpty) return options;
    return [safeDefault, ...options];
  }, [options, noEmpty, safeDefault]);

  const filteredOptions = useMemo(() => {
    if (!searchable || !query) return selectorOptions;
    const q = query.toLowerCase();
    return selectorOptions.filter((o) => o.label?.toLowerCase().includes(q));
  }, [selectorOptions, query, searchable]);

  const selectedValue = value || safeDefault;

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "center",
      }}
    >
      {label ? <Label className={styles.dropdownLabel}>{label}</Label> : null}
      <Popup
        dropdown
        searchable={searchable}
        expandBottomRight
        renderOpen={(onClick) => (
          <div
            onClick={onClick}
            className={styles.dropdownSelector}
            style={{
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <p
              style={{
                whiteSpace: "noWrap",
                overflow: "hidden",
                width: "100%",
                textOverflow: "ellipsis",
              }}
            >
              {selectedValue?.label || "-"}
            </p>
            <Icon chevronDown />
          </div>
        )}
      >
        {({ close }) => (
          <div className={styles.dropdownContent}>
            {searchable && (
              <div className={styles.dropdownHeader}>
                <Input
                  value={query}
                  onChange={(e) => {
                    setQuery(e.target.value);
                  }}
                  style={{ boxSizing: "border-box" }}
                  placeholder="Search..."
                />
              </div>
            )}
            <div className={styles.dropdownList}>
              {filteredOptions.map((option) => (
                <div
                  key={option.id}
                  onClick={() => {
                    onChange(option);
                    close();
                  }}
                  className={classNames(styles.selectorOption, {
                    [styles.selected]: option.id === selectedValue?.id,
                  })}
                >
                  {option.label}
                </div>
              ))}
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default DropdownSelector;
